module.exports = __webpack_public_path__ + "static/media/HookIcon.f9d93204.svg";